import { useAppVariant, useTranslations } from "@jugl-web/utils";
import { ReactNode } from "react";
import Lottie from "react-lottie";
import { Alert } from "../../feedback/Alert";
import { ConfirmationPopup } from "../../feedback/ConfirmationPopup";
import alertAnimation from "./assets/alert.json";

export interface DiscardDialogProps {
  isOpen: boolean;
  content?: ReactNode;
  onCancel: () => void;
  onDiscard: () => void;
}

export const DiscardDialog = ({
  isOpen,
  content,
  onCancel,
  onDiscard,
}: DiscardDialogProps) => {
  const { t } = useTranslations();
  const { variant } = useAppVariant();

  const title = t({
    id: "tasks-board-dialog.discard-changes",
    defaultMessage: "Discard changes",
  });

  const defaultContent = t({
    id: "tasks-board-dialog.discard-changes-description",
    defaultMessage: "If you discard, entered info will not be saved",
  });

  const cancelLabel = t({ id: "common.cancel", defaultMessage: "Cancel" });
  const discardLabel = t({ id: "common.discard", defaultMessage: "Discard" });

  const displayContent = content ?? defaultContent;

  if (variant === "mobile") {
    return (
      <ConfirmationPopup
        variant="mobile"
        isOpen={isOpen}
        title={title}
        message={
          <div className="text-center">
            <span className="font-secondary text-sm">{displayContent}</span>
          </div>
        }
        icon="alert"
        hasCancelButton
        buttons={[
          {
            label: discardLabel,
            color: "tertiary",
            onClick: onDiscard,
          },
        ]}
        onRequestClose={onCancel}
      />
    );
  }

  return (
    <Alert
      isOpen={isOpen}
      title={title}
      content={displayContent}
      className="z-[2001]"
      backdropClassName="z-[2000]"
      img={
        <Lottie
          options={{
            animationData: alertAnimation,
          }}
          height={70}
          width={70}
        />
      }
      buttons={[
        {
          text: cancelLabel,
          role: "close",
        },
        {
          text: discardLabel,
          color: "tertiary",
          onClick: onDiscard,
        },
      ]}
      onRequestClose={onCancel}
    />
  );
};
